import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { companyInfo, companyLogo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    // { label: 'Réalisations', href: '#realisations' }, // Masqué temporairement
    { label: 'À propos', href: '#about' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 md:pr-4">
        {/* Desktop Layout */}
        <div className="hidden md:flex items-center justify-between h-20">
          {/* Left: Company Name */}
          <a href="#" className="flex-shrink-0">
            <span className={`font-semibold text-lg tracking-tight transition-colors duration-300 ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              {companyInfo.name}
            </span>
          </a>

          {/* Center: Logo */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <img 
              src={companyLogo} 
              alt="Metaj Construction Logo" 
              className="h-9 w-auto object-contain"
            />
          </div>

          {/* Right: Navigation (pushed more to the right) */}
          <nav className="flex items-center gap-5 ml-auto">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className={`text-sm font-medium transition-colors duration-200 ${
                  isScrolled 
                    ? 'text-gray-600 hover:text-gray-900' 
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => scrollToSection(e, '#contact')}
              className={`text-sm font-medium px-5 py-2 rounded transition-all duration-200 ml-2 ${
                isScrolled 
                  ? 'bg-gray-900 text-white hover:bg-gray-800' 
                  : 'bg-white text-gray-900 hover:bg-gray-100'
              }`}
            >
              Contact
            </a>
          </nav>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden flex items-center justify-between h-16 relative">
          {/* Left: Company Name */}
          <a href="#" className="flex-shrink-0 z-10">
            <span className={`font-semibold text-xs tracking-tight transition-colors duration-300 ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              {companyInfo.name}
            </span>
          </a>

          {/* Center: Logo (absolute positioned) */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <img 
              src={companyLogo} 
              alt="Metaj Construction Logo" 
              className="h-7 w-auto object-contain"
            />
          </div>

          {/* Right: Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`p-2 transition-colors duration-300 z-10 ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden bg-white border-t border-gray-100 py-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="block text-gray-600 hover:text-gray-900 font-medium text-sm px-2 py-3"
              >
                {link.label}
              </a>
            ))}
            <div className="px-2 pt-3">
              <a
                href="#contact"
                onClick={(e) => scrollToSection(e, '#contact')}
                className="block w-full bg-gray-900 text-white text-center font-medium text-sm px-5 py-3 rounded hover:bg-gray-800 transition-colors"
              >
                Contact
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
